module.exports = __webpack_public_path__ + "img/arrow5.636cd9f6.svg";